<script>
    import _        from 'lodash'
    import Dropdown from '../../shared/Dropdown.svelte'
    
    export let filter
    export let inventory

    let placeQuery = ''
    let fieldQuery = ''
    let groupQuery = ''

    const debug = false

    function placeFilter(evt) {
        if(evt.key === 'Escape') {
            placeQuery = ''
        }
    }

    function fieldFilter(evt) {
        if(evt.key === 'Escape') {
            fieldQuery = ''
        }
    }

    function groupSelected(op) {
        groupQuery = op && op.text || ''
    }

    function any() {
        return () => true
    }

    function byPlaceGroup(wanted) {
        return place => {
            const result = place.group && place.group.toLowerCase() === wanted
            if(debug) console.log('byPlaceGroup', wanted, place.group, result)
            return result
        }
    }

    function byPlaceName(wanted) {
        return place => {
            const result = place.name.toLowerCase().indexOf(wanted) >= 0
            if(debug) console.log('byPlaceName', wanted, place.name, result)
            return result
        }
    }

    function byFieldName(wanted) {
        return place => {
            return place.fields.find(field => {
                const result = field.definition.toLowerCase().indexOf(wanted) >= 0 || field.name && field.name.toLowerCase().indexOf(wanted) >= 0
                if(debug) console.log('byFieldName', wanted, field.definition, result)
                return result
            })
        }
    }

    function composeFilter(placeQuery, fieldQuery, groupQuery) {

        const filters = [
            { query: placeQuery, fn: byPlaceName  },
            { query: groupQuery, fn: byPlaceGroup },
            { query: fieldQuery, fn: byFieldName  },
        ]

        const fns = filters
            .filter (i => i.query && i.query !== '')
            .map    (i => i.fn(i.query.toLowerCase()))

        if(fns.length > 0) {
            return place => fns.every(fn => fn(place))
        } else {
            return any
        }
    }

    $: filter = composeFilter(placeQuery, fieldQuery, groupQuery)
    $: groups = inventory.placeGroups()
</script>

<div class="filter">
    <div style="flex:1"></div>
    <Dropdown text="Grupo" noOption={true} options={groups} onChange={groupSelected} />

    <div class="ui icon input">
        <input  type="text" 
                placeholder="lugar"
                bind:value={placeQuery}                    
                on:keyup={placeFilter}>
        <i class="search link icon"></i>
    </div>
    <div class="ui icon input">
        <input  type="text" 
                placeholder="campo"
                bind:value={fieldQuery}                    
                on:keyup={fieldFilter}>
        <i class="search link icon"></i>
    </div>
</div>

<style>
    .filter {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
    }

    .filter .input {
        margin-left: 1em;
    }
</style>
